<script>
  import { createEventDispatcher, onMount } from "svelte";
  import Navigate from "../Classes/Navigate";
  import { permissaoUsuario } from "../Classes/Stores";
  import { logado, atualizarLogado } from "../Classes/EstadoLogado";
  import Constantes from "../Classes/Constantes";
  import { ItemMenus } from "../Classes/ItemMenus";
  
  let navi = new Navigate();
  const dispatch = createEventDispatcher();
  let logadoValor = false;
  export let itens = [];
  export let background = "";

  const unsubscribe = logado.subscribe((value) => {
    logadoValor = value;
  });

  onMount(() => {
    return unsubscribe;
  });

  function NavegarPara(item) {
    if (item.logout) {
      localStorage.setItem("token", "");
      localStorage.setItem("usuario", "");
      localStorage.setItem("id_empresa", "");
      Constantes.logado = false;
      atualizarLogado(false);
      navi.goTo("/");
    }
    navi.goTo(item.navegarPara);
    dispatch("close");
  }
</script>

<div class="back" style="background-image: url({background});">
  <div class="container">
    <div class="card-wrapper">
      {#each itens as item}
        {#if (item.SoLogado == false && item.login != true) || ((item.SoLogado == false || (item.SoLogado && $logado)) && item.login != true && $logado)}
          {#if item.permissao == "" || item.SoLogado == false || ($permissaoUsuario && (item.permissao in $permissaoUsuario.permissoes || $permissaoUsuario.permissoes.includes(item.permissao)))}
            <div class="card" on:click={() => NavegarPara(item)}>
              <div class="card-icon">
                {#if item.icone}
                  <i class={item.icone}></i>
                {/if}
              </div>
              <div class="card-title">{item.nome}</div>
            </div>
          {/if}
        {:else if item.login == true && !$logado}
          <div class="card" on:click={() => NavegarPara(item)}>
            <div class="card-icon">
              {#if item.icone}
                <i class={item.icone}></i>
              {/if}
            </div>
            <div class="card-title">{item.nome}</div>
          </div>
        {/if}
      {/each}
    </div>
  </div>
</div>

<style>
  .back {
    width: 100%;
    min-height: 100vh;
    background-size: cover;
    background-position: center;
    background-color: #f0f0f0; /* Cinza bem clarinho */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 20px;
  }

  .card-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* Espaçamento uniforme entre os cards */
    max-width: 400px; /* Largura máxima do wrapper ajustada */
    justify-content: center; /* Centraliza os cards horizontalmente */
  }

  .card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 80px; /* Largura ajustada dos cards */
    height: 80px; /* Altura ajustada dos cards */
    transition: background 0.3s, color 0.3s, transform 0.3s, box-shadow 0.3s;
    cursor: pointer;
  }

  .card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }

  .card-icon {
    font-size: 24px; /* Tamanho do ícone ajustado */
    margin-bottom: 4px; /* Espaçamento abaixo do ícone ajustado */
  }

  .card-title {
    font-size: 10px; /* Tamanho da fonte do título ajustado */
    font-weight: bold;
  }
</style>
